import FormWrapper from "../FormWrapper/FormWrapper";
import { FcCheckmark } from "react-icons/fc";

const CompleteApplicationForm = () => {
  return (
    <FormWrapper title="Sitter application">
      <FcCheckmark />
      CompleteApplicationForm
    </FormWrapper>
  );
};

export default CompleteApplicationForm;
